import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { useUserRole } from '../../context/UserRoleContext';
import { navigationConfig, navigationGroups } from '../../data/navigationConfig';
import { SidebarItem } from './SidebarItem';

export const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { role } = useUserRole();

  const filteredNav = navigationConfig.filter(item =>
    item.roles.includes(role)
  );

  return (
    <aside
      className={`${isCollapsed ? 'w-20' : 'w-80'} flex flex-col h-full transition-all duration-300 relative z-40`}
      style={{ backgroundColor: '#163F8C' }}
    >
      {/* Brand */}
      <div className="h-20 flex items-center px-6 border-b border-white/5">
        <Link to="/dashboard" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-xl shadow-indigo-500/20">
            <SafeIcon name="Hexagon" className="text-2xl" />
          </div>
          {!isCollapsed && (
            <span className="font-black text-xl text-white tracking-tighter uppercase">HMS-innsikt</span>
          )}
        </Link>
      </div>

      {/* Nav Items Grouped */}
      <div className="flex-1 py-6 px-4 space-y-8 overflow-y-auto thin-scrollbar">
        {navigationGroups.map(group => {
          const groupItems = filteredNav.filter(item => item.groupId === group.id);
          if (groupItems.length === 0 || !group.roles.includes(role)) return null;

          return (
            <div key={group.id}>
              {!isCollapsed && (
                <div className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em] px-3 mb-4">
                  {group.label}
                </div>
              )}
              <nav className="space-y-1">
                {groupItems.map((item) => (
                  <SidebarItem key={item.name} item={item} isCollapsed={isCollapsed} />
                ))}
              </nav>
            </div>
          );
        })}
      </div>

      {/* Footer / Collapse Toggle */}
      <div className="p-4 border-t border-white/5">
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-slate-400 hover:text-white hover:bg-white/5 transition-all"
        >
          <SafeIcon name={isCollapsed ? 'ChevronsRight' : 'ChevronsLeft'} className="text-lg" />
          {!isCollapsed && <span className="text-sm font-medium">Skjul navigasjon</span>}
        </button>
      </div>
    </aside>
  );
};